import React from 'react'
import PropTypes from 'prop-types'

class OverviewGraphActiveDot extends React.PureComponent {
  componentWillReceiveProps(nextProps) {
    if (this.props.cx !== nextProps.tooltipX) {
      this.props.onChange(nextProps)
    }
  }

  render() {
    const { cx, cy } = this.props
    return (
      <circle cx={cx} cy={cy} r={5} strokeWidth={3} stroke="#fff" fill="#419EF6" />
    )
  }
}

OverviewGraphActiveDot.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  open: PropTypes.bool,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  tooltipX: PropTypes.number,
}

export default OverviewGraphActiveDot



// WEBPACK FOOTER //
// ./src/components/atoms/OverviewGraphActiveDot.js